import {API_V1} from "../config/main-axios";

class FoodComments {
    getAllComments(data) {
        return API_V1.get("/api/survey/list/", {
            params: data
        })
    }
    updateStatus(id , data) {
        return API_V1.patch(`/api/survey/${id}/`, data)
    }
}

export default new FoodComments();